import { Group } from "@mantine/core";
import React from "react";
import { IconHelpText } from "../../../../components/IconHelpText/IconHelpText";
import { TruncatedHeader } from "../../../TruncatedHeader";

interface HeaderWithHelpIconProps {
  headerText: string | React.ReactNode;
  helpText: string;
}

function HeaderWithHelpIcon({ headerText, helpText }: HeaderWithHelpIconProps) {
  return (
    <Group className="header-with-help-icon" gap="xs" wrap="nowrap">
      <TruncatedHeader>{headerText}</TruncatedHeader>
      <IconHelpText helpText={helpText} />
    </Group>
  );
}

export { HeaderWithHelpIcon };
